/**重置Notification 不同类型添加不同类名 */
import { Notification } from "element-ui";
const notification = (options) => {
    const customClass = options?.customClass?.split(' ') || []
    options.customClass = [...customClass,`my-${options.type || 'success'}`].join(' ')
    Notification(options);
}

export default notification
